/**
 * @fileoverview Agent definition for key-events-neutralizer-v1.
 *
 * Rewrites chapter Key Events and Chapter Goals in a neutral, functional
 * tone, stripping flowery atmospheric prose while preserving every beat.
 *
 * @category narrative.chapters.planning
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'key-events-neutralizer-v1',
  kind: 'primitive',
  name: 'Key Events Neutralizer',
  description:
    'Rewrites chapter Key Events and Chapter Goals in a neutral, functional tone. Strips flowery atmospheric prose while preserving every beat, decision, and outcome.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-05',
    lastUpdated: '2026-05',
    taxonomyPath: 'narrative.chapters.planning',
    usedBy: [
      'primitives/use-key-events-neutralizer-v1.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'key-events-expander-v2',
      'chapter-planner-v2',
    ],
  },
};
